import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Card from "../../../UI/Card/Card";
import Button from "../../../UI/Button/Button"
import ErrorPanel, { ErrorSize } from "../../../UI/ErrorPanel/ErrorPanel";
import { faEdit, faTrashAlt, faFolderOpen, faCopy } from "@fortawesome/free-solid-svg-icons";
import styles from "../Applications.module.scss";

import * as PushNotificationUtils from "../../../Utils/PushNotificationUtils";
import * as ApplicationsUtils from "../../../Utils/ApplicationsUtils";
import * as FileUtils from "../../../Utils/FileUtils";
import * as ApplicationsActions from "../../../../middleware/Store/Actions/ApplicationsActions";
import * as SandBoxApplicationsActions from "../../../../middleware/Store/Actions/SandBoxApplicationsActions";
import * as ErrorUtils from "../../../Utils/ErrorUtils";
import { IosDocumentationGettingStartedUrl } from "../../../Constants/DocumentationConstant";
import { IosCertificateType } from "../../../Constants/ApplicationConstant";
import LogService from "../../../../middleware/CommonSdk/LogService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LOG_TAG = "APP-EDITION-IOS-PNS";

const IosPns = (props) => {
    const intl = useIntl();
    const [activation, setActivation] = useState({
        [IosCertificateType.Im]: false,
        [IosCertificateType.Voip]: false
    });
    const [pnsfile, setPnsfile] = useState({
        [IosCertificateType.Im]: null,
        [IosCertificateType.Voip]: null
    });
    const [application, setApplication] = useState(null);
    const [progressUpdate, setProgressUpdate] = useState({
        [IosCertificateType.Im]: false,
        [IosCertificateType.Voip]: false
    });
    const [progressDelete, setProgressDelete] = useState({
        [IosCertificateType.Im]: false,
        [IosCertificateType.Voip]: false
    });
    const [errorMessage, setErrorMessage] = useState({
        [IosCertificateType.Im]: "",
        [IosCertificateType.Voip]: ""
    });

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect application");
        if (props.applicationId) {
            const foundApplication = ApplicationsUtils.getApplicationById(props.applicationId, props.applications);
            setApplication(foundApplication);
            const imActivation = PushNotificationUtils.isEnabled(PushNotificationUtils.getIosPns(ApplicationsUtils.getPushNotification(foundApplication), IosCertificateType.Im));
            const voipActivation = PushNotificationUtils.isEnabled(PushNotificationUtils.getIosPns(ApplicationsUtils.getPushNotification(foundApplication), IosCertificateType.Voip));
            setActivation({
                [IosCertificateType.Im]: imActivation,
                [IosCertificateType.Voip]: voipActivation
            });

            if (props.applicationId !== application?.id) {
                setProgressUpdate({
                    [IosCertificateType.Im]: false,
                    [IosCertificateType.Voip]: false
                });
                setProgressDelete({
                    [IosCertificateType.Im]: false,
                    [IosCertificateType.Voip]: false
                });
                setErrorMessage("");
            }
        }
    }, [props.applications, props.applicationId]);


    const handleFileChoose = (certificateType, event) => {
        let newPnsfile = { ...pnsfile };
        newPnsfile[certificateType] = event.target.files[0];
        setPnsfile(newPnsfile);
        // Allow to select again same file
        event.target.value = null;

        let error = { ...errorMessage };
        error[certificateType] = "";
        setErrorMessage(error);
    }

    const handleFileDelete = (certificateType) => {
        let newPnsfile = { ...pnsfile };
        newPnsfile[certificateType] = null;
        setPnsfile(newPnsfile);

        let error = { ...errorMessage };
        error[certificateType] = "";
        setErrorMessage(error);
    }

    const handleActivationChange = (certificateType, event) => {
        let newActivation = { ...activation };
        newActivation[certificateType] = event.target.value;
        setActivation(newActivation);
    }

    const handleUpdate = (certificateType) => {
        LogService.trace(LOG_TAG, "handleUpdate");

        let progress = { ...progressUpdate };
        progress[certificateType] = true;
        setProgressUpdate(progress);
        const pns = PushNotificationUtils.getIosPns(ApplicationsUtils.getPushNotification(application), certificateType);
        let pnsId = pns?.id;
        let needReadCertificateFile = Promise.resolve(null);
        if (pnsfile[certificateType]) {
            LogService.debug(LOG_TAG, "handlePushUpdate", "read certficate file");
            needReadCertificateFile = FileUtils.readAFile(pnsfile[certificateType]);
        }

        needReadCertificateFile
            .then((fileContent) => props.pushUpdate(application?.id, pnsId, activation[certificateType], certificateType, fileContent, null))
            .then(() => {
                LogService.debug(LOG_TAG, "handlePushUpdate", "needReadCertificateFile success");
                let progress = { ...progressUpdate };
                progress[certificateType] = false;
                setProgressUpdate(progress);
            })
            .catch((errorPayload) => {
                LogService.debug(LOG_TAG, "handlePushUpdate", "needReadCertificateFile error", errorPayload);
                let progress = { ...progressUpdate };
                progress[certificateType] = false;
                setProgressUpdate(progress);

                let error = { ...errorMessage };
                error[certificateType] = ErrorUtils.getPrettyErrorMessage(errorPayload, intl);
                setErrorMessage(error);
            });
    };

    const handleDelete = (certificateType) => {
        LogService.trace(LOG_TAG, "handleDelete");

        let progress = { ...progressDelete };
        progress[certificateType] = true;
        setProgressDelete(progress);
        const pns = PushNotificationUtils.getIosPns(ApplicationsUtils.getPushNotification(application), certificateType);
        props.pushDelete(application?.id, pns.id)
            .then(() => {
                LogService.debug(LOG_TAG, "handleDelete success");
                let progress = { ...progressDelete };
                progress[certificateType] = false;
                setProgressDelete(progress);
            })
            .catch((errorPayload) => {
                LogService.debug(LOG_TAG, "handleDelete error");
                let progress = { ...progressDelete };
                progress[certificateType] = false;
                setProgressDelete(progress);

                let error = { ...errorMessage };
                error[certificateType] = ErrorUtils.getPrettyErrorMessage(errorPayload, intl);
                setErrorMessage(error);
            });
    };

    LogService.trace(LOG_TAG, "render");

    const pnsIM = PushNotificationUtils.getIosPns(ApplicationsUtils.getPushNotification(application), IosCertificateType.Im);
    const pnsVOIP = PushNotificationUtils.getIosPns(ApplicationsUtils.getPushNotification(application), IosCertificateType.Voip);

    const fingerprintIM = PushNotificationUtils.getCertificateFingerPrint(pnsIM);
    const fingerprintVOIP = PushNotificationUtils.getCertificateFingerPrint(pnsVOIP);

    const imCertificateExpirationDateDisplay = PushNotificationUtils.getPrettyCertificateExpirationDate(pnsIM, intl);
    let imCertificateExpirationMessage = "";
    if (PushNotificationUtils.isCertificateExpired(pnsIM)) {
        imCertificateExpirationMessage = intl.messages.applicationEditionIosPnsCertificateExpiredMessage;
    }

    const voipCertificateExpirationDateDisplay = PushNotificationUtils.getPrettyCertificateExpirationDate(pnsVOIP, intl);
    let voipCertificateExpirationMessage = "";
    if (PushNotificationUtils.isCertificateExpired(pnsVOIP)) {
        voipCertificateExpirationMessage = intl.messages.applicationEditionIosPnsCertificateExpiredMessage;
    }

    const disableUpdateImButton = (fingerprintIM.length === 0 && !pnsfile[IosCertificateType.Im]);
    const disableUpdateVoipButton = (fingerprintVOIP.length === 0 && !pnsfile[IosCertificateType.Voip]);

    let imErrorMessageDisplay = null;
    if (errorMessage[IosCertificateType.Im]) {
        imErrorMessageDisplay =
            <div id="ios-apns-error-message" className="mt-2">
                <ErrorPanel size={ErrorSize.Small} >{errorMessage[IosCertificateType.Im]}</ErrorPanel>
            </div>
    }

    let voipErrorMessageDisplay = null;
    if (errorMessage[IosCertificateType.Voip]) {
        voipErrorMessageDisplay =
            <div id="ios-apns-voip-error-message" className="mt-2">
                <ErrorPanel size={ErrorSize.Small} >{errorMessage[IosCertificateType.Voip]}</ErrorPanel>
            </div>
    }

    const docLink = <a
        rel="noopener noreferrer"
        target="_blank"
        href={IosDocumentationGettingStartedUrl}
    >
        {intl.messages.applicationEditionIosPnsAppBundleIdDocumentationLinkMessage}
    </a>

    const pushNotificationMessage = intl.formatMessage({ id: "applicationEditionIosPnsMessage" }, { link: docLink, b: chunks => <b>{chunks}</b> });
    let cardDisplay = null;
    if (pnsIM || pnsVOIP || ApplicationsUtils.isMobileApplication(application)) {
        cardDisplay =
            <Card title={intl.messages.applicationEditionIosPnsTitle}>
                <div className="panel bg-fog mb-3">{pushNotificationMessage}</div>

                {/* IM notification */}
                <h6 className="panel-lineTitle text-center text-silver my-4"><span className="pl-2">{intl.messages.applicationEditionIosPnsImTitle}</span>
                </h6>
                <div className="form-group">
                    <label className="input-label">{intl.messages.applicationEditionIosPnsImCertificateFileTitle}</label>
                    <div className="d-flex align-items-center">
                        <input
                            id="ios-apns-filechoose-input"
                            type="file"
                            accept=".pem"
                            className="d-none"
                            onChange={(event) => handleFileChoose(IosCertificateType.Im, event)}
                            disabled={!props.isUpdateEnabled}
                        />
                        <label
                            htmlFor="ios-apns-filechoose-input"
                            className="btn btn-gray mb-0 text-nowrap"
                        >
                            <FontAwesomeIcon className="btn-file mr-2" icon={faFolderOpen} />
                            {intl.messages.applicationEditionIosPnsCertificateFileButton}
                        </label>
                        <div
                            id="ios-apns-filename"
                            className={"ml-2 text-smoke border-bottom border-smoke " + styles.fileInputName}
                        >
                            {pnsfile && pnsfile[IosCertificateType.Im] ? pnsfile[IosCertificateType.Im].name : intl.messages.applicationEditionIosPnsCertificateFileNoFileMessage}
                            {pnsfile && pnsfile[IosCertificateType.Im] &&
                                <Button
                                    id="ios-apns-delete-file-button"
                                    icon={faTrashAlt}
                                    onClick={() => handleFileDelete(IosCertificateType.Im)}
                                    className="btn-icon btn-icon-danger float-right ml-2 mr-2"
                                />
                            }
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label className="input-label">{intl.messages.applicationEditionIosPnsActivationTitle}</label>
                    <select className="form-control mb-3"
                        id="ios-apns-activation-select"
                        value={activation[IosCertificateType.Im]}
                        onChange={(event) => handleActivationChange(IosCertificateType.Im, event)}
                        disabled={!props.isUpdateEnabled}
                    >
                        <option value={false} key={false}>{intl.messages.no} </option>
                        <option value={true} key={true}>{intl.messages.yes} </option>
                    </select>
                </div>

                {fingerprintIM.length > 0 &&
                    <div className="form-group">
                        <label className="input-label mt-2">{intl.messages.applicationEditionIosPnsImFingerPrintTitle}</label>
                        <div className="input-group mb-3">
                            <input
                                id="ios-apns-fingerprint-input"
                                disabled
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={fingerprintIM}
                            />
                            <div className="input-group-append">
                                <button className="btn input-btn" type="button" onClick={() => { navigator.clipboard.writeText(fingerprintIM) }}>
                                    <FontAwesomeIcon icon={faCopy} />
                                </button>
                            </div>
                        </div>

                        <label className="input-label mt-2">{intl.messages.applicationEditionIosPnsExpirationTitle}</label>
                        <div className="input-group">
                            <input
                                id="ios-apns-certificate-expiration-date"
                                disabled
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={imCertificateExpirationDateDisplay}
                            />
                            <div className="input-group-append">
                                <button className="btn input-btn" type="button" onClick={() => { navigator.clipboard.writeText(imCertificateExpirationDateDisplay) }}>
                                    <FontAwesomeIcon icon={faCopy} />
                                </button>
                            </div>
                        </div>
                        {imCertificateExpirationMessage.length > 0 &&
                            <ErrorPanel
                                id="ios-apns-certificate-expiration-error-message"
                                size={ErrorSize.Small}
                            >
                                {imCertificateExpirationMessage}
                            </ErrorPanel>
                        }
                    </div>
                }

                {props.isUpdateEnabled &&
                    <div className="form-group">
                        {pnsIM?.id &&
                            <Button
                                id="ios-apns-delete-btn"
                                label={intl.messages.delete}
                                className="btn-danger mr-2"
                                icon={faTrashAlt}
                                onClick={() => handleDelete(IosCertificateType.Im)}
                                spinner={progressDelete[IosCertificateType.Im]}
                                disabled={progressDelete[IosCertificateType.Im]}
                            />
                        }
                        <Button
                            id="ios-apns-update-btn"
                            className="btn-submit"
                            label={intl.messages.update}
                            icon={faEdit}
                            onClick={() => handleUpdate(IosCertificateType.Im)}
                            spinner={progressUpdate[IosCertificateType.Im]}
                            disabled={progressUpdate[IosCertificateType.Im] || disableUpdateImButton}
                        />
                        {imErrorMessageDisplay}
                    </div>
                }
                {/* VOIP notification */}
                <h6 className="panel-lineTitle text-center text-silver my-4">
                    <span className="pl-2">{intl.messages.applicationEditionIosPnsVoipTitle}</span>
                </h6>
                <div className="form-group">
                    <label className="input-label">{intl.messages.applicationEditionIosPnsVoipCertificateFileTitle}</label>
                    <div className="d-flex align-items-center">
                        <input
                            id="ios-apns-voip-filechoose-input"
                            type="file"
                            accept=".pem"
                            className="d-none"
                            onChange={(event) => handleFileChoose(IosCertificateType.Voip, event)}
                            disabled={!props.isUpdateEnabled}
                        />
                        <label
                            htmlFor="ios-apns-voip-filechoose-input"
                            className="btn btn-gray mb-0 text-nowrap"
                        >
                            <FontAwesomeIcon className="btn-file mr-2" icon={faFolderOpen}/>
                            {intl.messages.applicationEditionIosPnsCertificateFileButton}
                        </label>
                        <div
                            id="ios-apns-voip-filename"
                            className={"ml-2 text-smoke border-bottom border-smoke " + styles.fileInputName}
                        >
                            {pnsfile && pnsfile[IosCertificateType.Voip] ? pnsfile[IosCertificateType.Voip].name : intl.messages.applicationEditionIosPnsCertificateFileNoFileMessage}
                            {pnsfile && pnsfile[IosCertificateType.Voip] &&
                                <Button
                                    id="ios-apns-voip-delete-file-button"
                                    icon={faTrashAlt}
                                    onClick={() => handleFileDelete(IosCertificateType.Voip)}
                                    className="btn-icon btn-icon-danger float-right ml-2 mr-2"
                                />
                            }
                        </div>
                    </div>
                </div>

                <div className="form-group">
                    <label className="input-label">{intl.messages.applicationEditionIosPnsActivationTitle}</label>
                    <select className="form-control mb-3"
                        id="ios-apns-voip-activation-select"
                        value={activation[IosCertificateType.Voip]}
                        onChange={(event) => handleActivationChange(IosCertificateType.Voip, event)}
                        disabled={!props.isUpdateEnabled}
                    >
                        <option value={false} key={false}>{intl.messages.no} </option>
                        <option value={true} key={true}>{intl.messages.yes} </option>
                    </select>
                </div>

                {fingerprintVOIP.length > 0 &&
                    <div className="form-group">
                        <label className="input-label mt-2">{intl.messages.applicationEditionIosPnsVoipFingerPrintTitle}</label>
                        <div className="input-group mb-3">
                            <input
                                id="ios-apns-voip-fingerprint-input"
                                disabled
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={fingerprintVOIP}
                            />
                            <div className="input-group-append">
                                <button className="btn input-btn" type="button" onClick={() => { navigator.clipboard.writeText(fingerprintVOIP) }}>
                                    <FontAwesomeIcon icon={faCopy} />
                                </button>
                            </div>
                        </div>

                        <label className="input-label mt-2">{intl.messages.applicationEditionIosPnsExpirationTitle}</label>
                        <div className="input-group">
                            <input
                                id="ios-apns-voip-certificate-expiration-date"
                                disabled
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                value={voipCertificateExpirationDateDisplay}
                            />
                            <div className="input-group-append">
                                <button className="btn input-btn" type="button" onClick={() => { navigator.clipboard.writeText(voipCertificateExpirationDateDisplay) }}>
                                    <FontAwesomeIcon icon={faCopy} />
                                </button>
                            </div>
                        </div>
                        {voipCertificateExpirationMessage.length > 0 &&
                            <ErrorPanel
                                id="ios-apns-voip-certificate-expiration-error-message"
                                size={ErrorSize.Small}
                            >
                                {voipCertificateExpirationMessage}
                            </ErrorPanel>
                        }
                    </div>
                }

                {props.isUpdateEnabled &&
                    <div>
                        {pnsVOIP?.id &&
                            <Button
                                id="ios-apns-voip-delete-btn"
                                label={intl.messages.delete}
                                className="btn-warning mr-2"
                                icon={faTrashAlt}
                                onClick={() => handleDelete(IosCertificateType.Voip)}
                                spinner={progressDelete[IosCertificateType.Voip]}
                                disabled={progressDelete[IosCertificateType.Voip]}
                            />
                        }
                        <Button
                            id="ios-apns-voip-update-btn"
                            label={intl.messages.update}
                            icon={faEdit}
                            onClick={() => handleUpdate(IosCertificateType.Voip)}
                            spinner={progressUpdate[IosCertificateType.Voip]}
                            disabled={progressUpdate[IosCertificateType.Voip] || disableUpdateVoipButton}
                            className="btn-submit"
                        />
                        {voipErrorMessageDisplay}
                    </div>
                }
            </Card >
    }

    return <div>{cardDisplay}</div>
}

IosPns.propTypes = {
    applicationId: PropTypes.string,
    isUpdateEnabled: PropTypes.bool,
    isSandBoxApplication: PropTypes.bool
};

IosPns.defaultProps = {
    applicationId: "",
    isUpdateEnabled: false,
    isSandBoxApplication: false
}

const mapStateToProps = (state, props) => {
    return {
        applications: props.isSandBoxApplication ? state.sandBoxApplications.applications : state.applications.applications
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        pushDelete: (appId, pnId) => dispatch(props.isSandBoxApplication ? SandBoxApplicationsActions.deletePushNotification(appId, pnId) : ApplicationsActions.deletePushNotification(appId, pnId)),
        pushUpdate: (appId, pnId, isEnabled, certficateType, certificateFile, appBundleId) => dispatch(props.isSandBoxApplication ? SandBoxApplicationsActions.addOrUpdatePushNotificationIos(appId, pnId, isEnabled, certficateType, certificateFile, appBundleId) : ApplicationsActions.addOrUpdatePushNotificationIos(appId, pnId, isEnabled, certficateType, certificateFile, appBundleId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IosPns);